$( document ).ready(function() {
    //carrinho
    // if($('body#cart').length > 0){
    //     //remove  minicart conflito
    //     $('.drawer__inner, #CartDrawer-Overlay, cart-drawer').remove()

    //     //check cep digitado
    //     const cepDelivery = localStorage.getItem('cepDelivery')
    //     if(cepDelivery != null){
    //         // $('.drawer__cart-items-wrapper').addClass('loading');
    //         $('#cart .cart__items > .js-contents').addClass('loading');
    //         $('.containerCepMincart #address_zip').val(cepDelivery);
    //         $('.containerCepMincart .get-rates-custom').trigger('click');
    //     }else{
    //         $('#cart .cart__items table.cart-items').show();
    //         $('#cart .cart__items > .js-contents').removeClass('loading');
    //     }
    // }

});